import { API_URL } from '@api/apiDictionary';
import { RESTClient } from '@api/client';
import { OrganizationType } from '@dynamika-shared/types/inventory';
import {
  PaginatedArgs,
  PaginatedResponse,
} from '@dynamika-shared/types/general';

export const fetchOrganizationList = async (args?: PaginatedArgs) => {
  return RESTClient.get<PaginatedResponse<OrganizationType>>(
    API_URL.organizations,
    {
      params: {
        page: args?.page ? args?.page - 1 : 0,
        size: args?.size ?? 15,
        sort: args?.sort,
        name: args?.name,
      },
    }
  );
};
export const fetchAllOrganizationList = async () => {
  return RESTClient.get<OrganizationType[]>(API_URL.organizationsAll);
};
